/**
 * NC-1663 (Beta-Audit E2E-03): one place for the hint shown next to a VM address.
 *
 * Since D12 a run's VMs get a private address by default (`addressKind=private`).
 * A participant then saw a 10.31.x address with no explanation and a connection
 * that fails from home (#1404). Participant page and welcome card both use this,
 * so the wording cannot drift between them.
 *
 * Bastion (M22, #1619/#1620) may later replace the hint with a real access path.
 */
export const PRIVATE_ADDRESS_HINT =
  'Nur aus dem Schulungsnetz erreichbar — bitte von einem Rechner im Schulungsraum verbinden.';

/**
 * The hint for an address kind, or null. Only `private` gets one; `public`,
 * `none` and unknown values (an older or newer API) stay silent.
 */
export function addressHint(addressKind: string | null | undefined): string | null {
  return addressKind === 'private' ? PRIVATE_ADDRESS_HINT : null;
}
